import { passwordInterface } from "../interface/MypageInterface";

export const initPasswordReq : passwordInterface = {
    userId : 0,
    password : "",
    newPassword : "",
    newPasswordChk : ""
}